<template>
  <div class="carousel_wrap">
    <el-carousel height="890px" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.image" alt="" class="img_item" />
        <div class="tips_font">
          <div class="coName">
            <span class="t1">{{ $store.state.company.name }}</span>
            <span class="t2"></span>
          </div>
          <div class="enCoName">{{ $store.state.company.name_en }}</div>
          <div class="slogan">{{ $store.state.company.aim }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <el-image :src="item.image" lazy class="img_item" />
        <div class="tips_font">
          <div class="coName">
            <span class="t1">利川市靓利建设工程有限公司</span>
            <span class="t2">有限公司</span>
          </div>
          <div class="enCoName">Lichuan Liangli Construction Engineering Co., LTD</div>
          <div class="slogan">以实现优质服务承诺为目的，全面提升服务质量与水平</div>
        </div>
      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="scss">
.img_item{
  width: 100%;
  height: 100%;
}
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 165px;
    left: 422px;
    z-index: 5;
    color: #fff;
    background: linear-gradient( 90deg, #4B98D8 0%, rgba(68,146,209,0.9) 17%, rgba(74,151,211,0) 100%);
    border-radius: 6px;
    padding: 35px 40px;
    .coName{
      display: flex;
      flex-direction: row;
      align-items: baseline;
      .t1{
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 42px;
        color: #FFFFFF;
        line-height: 49px;
      }
    }
    .enCoName {
      font-weight: bold;
      font-size: 28px;
      color: #2A59A9;
      line-height: 33px;
      text-shadow: 0px 4px 4px rgba(255,255,255,0.25);
      margin-top: 19px;
      font-family: Source Han Sans SC;
    }
    .slogan {
      font-size:22px;
      color: #fff;
      margin-top: 14px;
      font-family: Source Han Sans SC;
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>